import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";

export interface SavedSeoArticle {
  keyword: string;
  content_markdown: string;
  title?: string;
  description?: string;
  tags?: string[];
  angle?: string | null;
  created_at: string;
  updated_at: string;
}

interface SavedSeoArticleResponse {
  status: string;
  data: SavedSeoArticle | null;
}

const useSeoArticleApi = () => {
  const { get, put } = useHttpAdapter();

  const getSavedSeoArticle = useCallback(
    async (
      productId: string,
      keyword: string,
      angle?: string
    ): Promise<SavedSeoArticle | null> => {
      try {
        const query = new URLSearchParams({ keyword });
        if (angle) {
          query.set("angle", angle);
        }
        const response = await get<SavedSeoArticleResponse>(
          `/seo/article/${productId}?${query.toString()}`
        );
        return response.data?.data ?? null;
      } catch {
        return null;
      }
    },
    [get]
  );

  const saveSeoArticle = useCallback(
    async (
      productId: string,
      keyword: string,
      contentMarkdown: string,
      metadata?: {
        title?: string;
        description?: string;
        tags?: string[];
        angle?: string;
      },
      weeklyPlanItemId?: string
    ): Promise<SavedSeoArticle | null> => {
      try {
        const response = await put<SavedSeoArticleResponse>(
          `/seo/article/${productId}`,
          {
            keyword,
            content_markdown: contentMarkdown,
            title: metadata?.title,
            description: metadata?.description,
            tags: metadata?.tags,
            angle: metadata?.angle,
            weekly_plan_item_id: weeklyPlanItemId,
          }
        );
        return response.data?.data ?? null;
      } catch {
        return null;
      }
    },
    [put]
  );

  return { getSavedSeoArticle, saveSeoArticle };
};

export default useSeoArticleApi;
